<template>
  <el-popover
    placement="bottom-start"
    width="400"
    :disabled="disabledUse"
    trigger="click"
    transition="el-zoom-in-top"
    class="ips-org-tree"
    popper-class="ips-org-tree__popper"
    v-model="visible"
    @hide="handleHide"
  >
    <el-input
      v-if="!orgNode"
      slot="reference"
      v-model="name"
      :disabled="disabledUse"
      :clearable="true"
      class="ips-org-tree__input name"
      :class="{'ips-org-tree_arrow-down':!visible,'ips-org-tree_arrow-up':visible}"
      :placeholder="placeholder"
      suffix-icon="el-icon-arrow-up"
      @change="handleChange"
      @input="handleInput"
      @click.native="handleClick"
    ></el-input>
    <el-input
      v-else
      slot="reference"
      :disabled="disabledUse"
      v-model="orgNode.name"
      :clearable="true"
      class="ips-org-tree__input orgNode"
      :class="{'ips-org-tree_arrow-down':!visible,'ips-org-tree_arrow-up':visible}"
      :placeholder="placeholder"
      suffix-icon="el-icon-arrow-up"
      @change="handleChange"
      @input="handleInput"
      @click.native="handleClick"
    ></el-input>
    <div class="ips-org-tree__tree-container" ref="tree-container">
      <el-tree
        ref="tree"
        :data="data"
        :show-checkbox="showCheckBox"
        lazy
        node-key="id"
        :default-expanded-keys="defaultExpandedKeys"
        :default-checked-keys="defaultCheckedKeys"
        :props="defaultProps"
        :load="loadOrg"
        @node-click="handleNodeClick"
        @check-change="handleCheckChange"
        v-show="showType==1"
      ></el-tree>
      <div v-show="showType==2">
        <el-table :data="gridData" v-loading="loading" @row-click="rowClick" border width="400">
          <el-table-column type="selection" width="55" v-if="showCheckBox"></el-table-column>
          <el-table-column prop="name" label="姓名" width="120"></el-table-column>
          <el-table-column
            prop="fictitiousFullName"
            label="组织机构"
            show-overflow-tooltip
            min-width="220"
          ></el-table-column>
        </el-table>

        <div class="mgt-5">
          <el-pagination
            background
            :current-page.sync="pageNum"
            :page-size="pageSize"
            :page-sizes="PAGE_SIZES"
            @current-change="changePage"
            @size-change="changePageSize"
            layout="total, prev, pager, next"
            :total="total"
          ></el-pagination>
        </div>
      </div>
    </div>
  </el-popover>
</template>

<script>
  import BScroll from "better-scroll";
  import {utils} from "@/components";
  import {PAGE_LAYOUT, PAGE_SIZES, SCROLL_CONFIG} from "@/store/constant";
  import * as Types from "@/store/mutation-types";
  import _ from "lodash";
  import {mapState} from "vuex";

  /**
 * 员工树和列表的混合组件
 * TODO
 */
export default {
  name: "staffDropTree",
  props: {
    value: [Object, String],
    showCheckBox: Boolean,
    placeholder: String,
    onlyValue: [String, Number],
    id: [String, Number],
    name: String,
    disabledUse: Boolean,
  },
  data() {
    return {
      PAGE_LAYOUT,
      PAGE_SIZES,
      visible: false,
      showType: 1, // 1:显示树，2:显示列表
      defaultProps: {
        isLeaf: data => !data.children,
        label: "name",
        disabled: "disabled"
      },
      data: [],
      gridData: [],
      loading: false,
      pageNum: 1,
      pageSize: 5,
      total: 0
    };
  },
  computed: {
    ...mapState("app",["currentUser"]),
    singleSelect() {
      return !this.showCheckBox;
    },
    multiSelect() {
      return this.showCheckBox;
    },
    filterArr: function() {
      let result = ["ogn", "dpt", "pos", "psm"];
      switch (this.filterLevel) {
        case "ogn":
          result = ["ogn"];
          break;
        case "dpt":
          result = ["ogn", "dpt"];
          break;
        case "pos":
          result = ["ogn", "dpt", "pos"];
          break;
        case "psm":
          result = ["ogn", "dpt", "pos", "psm"];
          break;
        case "pro":
          result = ["ogn", "dpt"];
          break;
      }
      return result;
    },
    orgNode() {
      return this.value ? Object.assign({}, this.value) : null;
    }
  },
  methods: {
    loadOrg({ level, data }, resolve) {
      if (level === 0) {
        return this.$store
          .dispatch(Types.COMMON_ORG_TREE, this.currentUser.tenancyCode)
          .then(result => {
            let arr = result.filter(
              o => this.filterArr.indexOf(o.orgKindId) != -1
            );
            resolve(arr);
          })
          .catch(() => {
            resolve();
          });
      } else {
        return this.$store
          .dispatch(Types.COMMON_ORG_TREE, data.id)
          .then(result => {
            let arr = result.filter(
              o => this.filterArr.indexOf(o.orgKindId) != -1
            );
            if (this.filterLevel == "pro") {
              arr = arr.filter(o => o.typeSign != null && o.typeSign <= 9);
            }
            resolve(arr);
          })
          .catch(() => {
            resolve();
          });
      }
    },
    handleHide() {
      this.visible = false;
    },
    handleClick() {
      // this.visible = !this.visible
    },
    handleChange() {
      if (utils.isEmpty(this.name)) {
        this.$emit("input", {});
        this.$emit("change", {});
        this.$emit("update:id", "");
        this.$emit("update:name", "");
      }
    },
    handleInput() {
      if (utils.isEmpty(this.name)) {
        this.showType = 1;
      } else {
        this.showType = 2;
        this.pageNum = 1;
        this.getStaffsByName(this.name);
      }
    },
    getStaffsByName: _.debounce(function(name) {
      this.loading = true;
      this.$store
        .dispatch(Types.COMMON_STAFFS, {
          name,
          pageNum: this.pageNum,
          pageSize: this.pageSize
        })
        .then(data => {
          this.total = data.total;
          this.gridData = data.result;
        })
        .finally(() => {
          this.loading = false;
        });
    }, 500),
    finish(node) {
      this.$emit("input", node);
      this.$emit("change", node);
      this.visible = false;
      this.$emit("update:id", node.id);
      this.$emit("update:name", node.name);
    },
    handleNodeClick(node) {
      if (!this.showCheckBox) {
        if (this.onlyValue !== undefined) {
          if (this.onlyValue / 1 === node["typeSign"] / 1) {
            this.finish(node);
          }
        } else if (this.selectLevel) {
          if (this.selectLevel === node["orgKindId"]) {
            this.finish(node);
          }
        } else {
          this.finish(node);
        }
      }
    },
    handleCheckChange() {
      if (this.showCheckBox) {
        let nodes = this.$refs["tree"].getCheckedNodes(true);
        this.$emit("update:name", nodes.map(node => node.label).join());
        this.$emit("input", nodes);
        this.$emit("change", nodes);
      }
    },
    changePage() {
      this.getStaffsByName(this.name);
    },
    changePageSize() {},
    rowClick(rowData) {
      if (this.showCheckBox) return;
      this.name = rowData.name;
      this.finish(rowData);
    }
  },
  mounted() {
    new BScroll(this.$refs["tree-container"], SCROLL_CONFIG);
  }
};
</script>

<style lang="scss">
@import "../../assets/scss/dropTree.scss";
</style>
